<template>
  <header class="header anchor-first">
    <button id="menu-toggle" class="menu-toggle">
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </button>

    <div class="mobile-menu">
      <div class="menu_main_menu_container">
        <div class="menu__holder">
          <ul class="menu">
            <li class="menu__item">
              <router-link to="/" @click.native="closeMenu"
                ><img
                  src="@/assets/img/menu/menu_1.svg"
                  alt="TOP"
                />トップ</router-link
              >
            </li>
            <li class="menu__item">
              <router-link to="/event" @click.native="closeMenu"
                ><img
                  src="@/assets/img/menu/menu_2.svg"
                  alt="Event"
                />イベント</router-link
              >
            </li>
             <li class="menu__item">
              <router-link to="/myfavoritethings" @click.native="closeMenu"
                ><img
                  src="@/assets/img/menu/menu_7.svg"
                  alt="Myfavoritethings"
                />MY FAVORITE</router-link
              >
            </li>
            <li class="menu__item">
              <router-link to=""
                ><img
                  src="@/assets/img/menu/menu_3.svg"
                  alt="Shop"
                />ショップ</router-link
              >
              <button class="ques_expand"></button>
              <ul class="submenu">
                <li>
                  <router-link to="/shop-guide" @click.native="closeMenu"
                    >ショップガイド</router-link
                  >
                </li>
                <li>
                  <router-link to="/shop-news" @click.native="closeMenu"
                    >ショップニュース</router-link
                  >
                </li>
              </ul>
            </li>
            <li class="menu__item">
              <router-link to=""
                ><img src="@/assets/img/menu/menu_4.svg" alt="About" />HARUMI
                FLAGについて
              </router-link>
              <button class="ques_expand"></button>
              <ul class="submenu">
                <li>
                  <router-link to="/about/concept" @click.native="closeMenu"
                    >街中に出会いがある<br />にぎわいの街</router-link
                  >
                </li>
                <li>
                  <router-link to="/about/design" @click.native="closeMenu"
                    >地域全体のデザインに<br />一体感のある個性的な街</router-link
                  >
                </li>
                <li>
                  <router-link to="/about/location" @click.native="closeMenu"
                    >みんなで守り、<br />育てていく森の街</router-link
                  >
                </li>
                <li>
                  <router-link to="/about/eco" @click.native="closeMenu"
                    >様々なエネルギーを<br />巧みに使いこなす街</router-link
                  >
                </li>
                <li>
                  <router-link to="/about/legacy" @click.native="closeMenu"
                    >オリンピック・<br />パラリンピックの<br />レガシーが息づく街</router-link
                  >
                </li>
                <li>
                  <router-link to="/about/facility" @click.native="closeMenu"
                    >みんなが使いこなし<br />楽しみをつなぐ街</router-link
                  >
                </li>
              </ul>
            </li>
            <li class="menu__item">
              <router-link to=""
                ><img
                  src="@/assets/img/menu/menu_5.svg"
                  alt="Acess"
                />アクセス</router-link
              >
              <button class="ques_expand"></button>
              <ul class="submenu">
                <li v-if="accesstList.acf?.large_title_2">
                  <a
                    class="router-link-exact-active router-link-active"
                    @click="
                      handleMoveToAccess(`${accesstList.acf?.large_title_2}`)
                    "
                    >{{ accesstList.acf?.large_title_2 }}</a
                  >
                </li>
                <li v-if="accesstList.acf?.large_title_3">
                  <a
                    class="router-link-exact-active router-link-active"
                    @click="
                      handleMoveToAccess(`${accesstList.acf?.large_title_3}`)
                    "
                    >{{ accesstList.acf?.large_title_3 }}</a
                  >
                </li>
                <li v-if="accesstList.acf?.large_title_4">
                  <a
                    class="router-link-exact-active router-link-active"
                    @click="
                      handleMoveToAccess(`${accesstList.acf?.large_title_4}`)
                    "
                    >{{ accesstList.acf?.large_title_4 }}</a
                  >
                </li>
                <li v-if="accesstList.acf?.large_title_5">
                  <a
                    class="router-link-exact-active router-link-active"
                    @click="
                      handleMoveToAccess(`${accesstList.acf?.large_title_5}`)
                    "
                    >{{ accesstList.acf?.large_title_5 }}</a
                  >
                </li>
                <li v-if="accesstList.acf?.large_title_6">
                  <a
                    class="router-link-exact-active router-link-active"
                    @click="
                      handleMoveToAccess(`${accesstList.acf?.large_title_6}`)
                    "
                    >{{ accesstList.acf?.large_title_6 }}</a
                  >
                </li>
                <li v-if="accesstList.acf?.large_title_7">
                  <a
                    class="router-link-exact-active router-link-active"
                    @click="
                      handleMoveToAccess(`${accesstList.acf?.large_title_7}`)
                    "
                    >{{ accesstList.acf?.large_title_7 }}</a
                  >
                </li>
                <li v-if="accesstList.acf?.large_title_8">
                  <a
                    class="router-link-exact-active router-link-active"
                    @click="
                      handleMoveToAccess(`${accesstList.acf?.large_title_8}`)
                    "
                    >{{ accesstList.acf?.large_title_8 }}</a
                  >
                </li>
                <li v-if="accesstList.acf?.large_title_9">
                  <a
                    class="router-link-exact-active router-link-active"
                    @click="
                      handleMoveToAccess(`${accesstList.acf?.large_title_9}`)
                    "
                    >{{ accesstList.acf?.large_title_9 }}</a
                  >
                </li>
                <li v-if="accesstList.acf?.large_title_10">
                  <a
                    class="router-link-exact-active router-link-active"
                    @click="
                      handleMoveToAccess(`${accesstList.acf?.large_title_10}`)
                    "
                    >{{ accesstList.acf?.large_title_10 }}</a
                  >
                </li>
              </ul>
            </li>
            <li class="menu__item">
              <router-link to=""
                ><img
                  src="@/assets/img/menu/menu_6.svg"
                  alt="Energy"
                />環境</router-link
              >
              <button class="ques_expand"></button>
              <ul class="submenu">
                <li>
                  <router-link to="/energy" @click.native="closeMenu"
                    >エネルギーマネジメント</router-link
                  >
                </li>
                <li>
                  <router-link to="/energy-usage" @click.native="closeMenu"
                    >エネルギーの利用状況</router-link
                  >
                </li>
                <li>
                  <router-link to="/environment" @click.native="closeMenu"
                    >環境への配慮</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>
          <div class="btn__link sp">
            <div class="btn__holder">
              <a
                href="https://mansion.harumi-flag.net/app/login"
                target="_blank"
                class="btn"
                ><img
                  src="@/assets/img/top/door_link.svg"
                  alt=""
                />居住者ログイン</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="siteheader" id="site-header">
      <div class="siteheader__start">
        <div class="container">
          <div class="siteheader__start__holder">
            <div class="siteheader__logo pc">
              <router-link to="/"
                ><img
                  src="@/assets/img/header/header_logo_left.svg"
                  alt="HARUMIFLAGタウンポータル"
                />
              </router-link>
            </div>
            <div class="siteheader__logo--center">
              <h1>
                <router-link to="/" @click.native="titleHandleClick"
                  ><img
                    src="@/assets/img/header/header_logo_center.svg"
                    alt="TOP"
                /></router-link>
              </h1>
            </div>
            <div class="siteheader__link">
              <div class="btn__holder">
                <a
                  href="https://mansion.harumi-flag.net/app/login"
                  target="_blank"
                  class="btn"
                  ><img src="@/assets/img/top/door_link.svg" alt="" />居住者<br
                    class="sp"
                  />ログイン
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="siteheader__menu">
        <div class="menu_main_menu_container">
          <div class="menu__holder">
            <ul class="menu">
              <li
                class="menu__item"
                :class="{
                  active:
                    isActive('/') ||
                    isActive('/policy') ||
                    isActive('/privateinfo') ||
                    isActive('/privacypolicy') ||
                    isActive('/contact'),
                }"
              >
                <router-link to="/">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 33.94 22.1"
                  >
                    <rect
                      style=""
                      class="cls-1"
                      x="2.56"
                      y="9.5"
                      width="21.12"
                      height="1.21"
                      transform="translate(-.93 18.88) rotate(-69.62)"
                    />
                    <polygon
                      class="cls-1"
                      points="33.5 .21 29.06 12.15 14.79 12.15 19.23 .21 33.5 .21"
                    />
                    <path
                      class="cls-2"
                      d="m.89,17.89c3.22,0,3.22,3.33,6.43,3.33s3.21-3.33,6.43-3.33,3.22,3.33,6.43,3.33,3.22-3.33,6.44-3.33,3.22,3.33,6.44,3.33"
                    />
                  </svg>
                  トップ
                </router-link>
              </li>
              <li class="menu__item" :class="{ active: isActive('/event') }">
                <router-link to="/event">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20.81 21.4"
                  >
                    <path
                      class="cls-1"
                      d="m5.94,4.33c.67,0,1.21-.54,1.21-1.21v-1.91c0-.67-.54-1.21-1.21-1.21s-1.21.54-1.21,1.21v1.91c0,.67.54,1.21,1.21,1.21Z"
                    />
                    <path
                      class="cls-1"
                      d="m14.87,4.33c.67,0,1.21-.54,1.21-1.21v-1.91c0-.67-.54-1.21-1.21-1.21s-1.21.54-1.21,1.21v1.91c0,.67.54,1.21,1.21,1.21Z"
                    />
                    <path
                      class="cls-1"
                      d="m17.9,1.73h-.75v1.39c0,1.25-1.02,2.28-2.28,2.28s-2.28-1.02-2.28-2.28v-1.39h-4.38v1.39c0,1.25-1.02,2.28-2.28,2.28s-2.28-1.02-2.28-2.28v-1.39h-.75C1.31,1.73,0,3.03,0,4.64v13.84c0,1.61,1.31,2.92,2.92,2.92h14.98c1.61,0,2.92-1.31,2.92-2.92V4.64c0-1.61-1.31-2.92-2.92-2.92Zm.62,16.25c0,.75-.61,1.35-1.35,1.35H3.65c-.75,0-1.35-.61-1.35-1.35V7.14h16.22v10.83h0Z"
                    />
                    <rect
                      class="cls-1"
                      x="8.93"
                      y="14"
                      width="2.96"
                      height="2.96"
                    />
                    <rect
                      class="cls-1"
                      x="4.34"
                      y="14"
                      width="2.96"
                      height="2.96"
                    />
                    <rect
                      class="cls-1"
                      x="13.51"
                      y="9.41"
                      width="2.96"
                      height="2.96"
                    />
                    <rect
                      class="cls-1"
                      x="13.51"
                      y="14"
                      width="2.96"
                      height="2.96"
                    />
                    <rect
                      class="cls-1"
                      x="8.93"
                      y="9.41"
                      width="2.96"
                      height="2.96"
                    />
                    <rect
                      class="cls-1"
                      x="4.34"
                      y="9.41"
                      width="2.96"
                      height="2.96"
                    />
                  </svg>
                  イベント
                </router-link>
              </li>
              <li class="menu__item" :class="{ active: isActive('/myfavoritethings') }">
                <router-link to="/myfavoritethings">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 16">
                    <path class="cls-1" d="M11.5,6.75c-1.54,0-2.79,1.13-2.79,2.52s1.25,2.52,2.79,2.52,2.79-1.13,2.79-2.52-1.25-2.52-2.79-2.52Z"/>
                    <path class="cls-1" d="M21.51,3.17h-2.63c-.59,0-1.12-.31-1.36-.79l-.79-1.58c-.24-.48-.77-.79-1.36-.79h-7.73c-.59,0-1.12.31-1.36.79l-.79,1.58c-.24.48-.77.79-1.36.79H1.49c-.82,0-1.49.6-1.49,1.35v10.14c0,.74.67,1.35,1.49,1.35h20.01c.82,0,1.49-.6,1.49-1.35V4.52c0-.74-.67-1.35-1.49-1.35ZM11.5,14.3c-3.08,0-5.58-2.25-5.58-5.03s2.5-5.03,5.58-5.03,5.58,2.25,5.58,5.03-2.5,5.03-5.58,5.03Z"/>
                  </svg>
                  MY FAVORITE
                </router-link>
              </li>
              <li class="menu__item" :class="{ active: isActive('/shop') }">
                <router-link to="">
                  <svg
                    class="menu-item-3"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 23.77 18.42"
                  >
                    <polygon
                      class="cls-1"
                      points="1.92 8.71 1.92 18.42 9.1 18.42 9.1 11.8 14.67 11.8 14.67 18.42 21.85 18.42 21.85 8.71 1.92 8.71"
                    />
                    <polygon
                      class="cls-1"
                      points="10.68 0 7.36 0 6.68 6.63 10.5 6.63 10.68 0"
                    />
                    <polygon
                      class="cls-1"
                      points="17.09 6.63 16.41 0 13.09 0 13.27 6.63 17.09 6.63"
                    />
                    <polygon
                      class="cls-1"
                      points="23.77 6.63 22.22 0 18.81 0 19.85 6.63 23.77 6.63"
                    />
                    <polygon
                      class="cls-1"
                      points="4.96 0 1.55 0 0 6.63 3.92 6.63 4.96 0"
                    />
                  </svg>
                  ショップ
                </router-link>
                <ul>
                  <li>
                    <router-link to="/shop-guide">ショップガイド</router-link>
                  </li>
                  <li>
                    <router-link to="/shop-news">ショップニュース</router-link>
                  </li>
                </ul>
              </li>
              <li
                class="menu__item"
                :class="{
                  active:
                    isActive('/legacy') ||
                    isActive('/location') ||
                    isActive('/design') ||
                    isActive('/concept') ||
                    isActive('/eco') ||
                    isActive('/facility'),
                }"
              >
                <router-link to="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 21.34 21.34"
                  >
                    <path
                      class="cls-1"
                      d="m18.21,3.12C16.28,1.2,13.61,0,10.67,0c-2.94,0-5.62,1.2-7.54,3.12C1.2,5.05,0,7.73,0,10.67c0,2.94,1.2,5.62,3.12,7.54,1.93,1.93,4.6,3.13,7.54,3.12,2.94,0,5.62-1.2,7.54-3.12,1.93-1.93,3.13-4.6,3.12-7.54,0-2.94-1.2-5.62-3.12-7.54Zm-1.28,1.28c1.6,1.61,2.59,3.81,2.59,6.26,0,2.45-.99,4.65-2.59,6.26-1.61,1.6-3.81,2.59-6.26,2.59-2.45,0-4.65-.99-6.26-2.59-1.6-1.61-2.59-3.81-2.59-6.26,0-2.45.99-4.65,2.59-6.26,1.61-1.6,3.81-2.59,6.26-2.59,2.45,0,4.65.99,6.26,2.59Z"
                    />
                    <path
                      class="cls-1"
                      d="m10.06,14.01c-.65,0-1.17.52-1.17,1.17s.52,1.17,1.17,1.17,1.17-.53,1.17-1.17c0-.65-.52-1.17-1.17-1.17Z"
                    />
                    <path
                      class="cls-1"
                      d="m7.41,6.93l.8.64c.16.13.4.13.55-.01,0,0,.1-.18.41-.35.31-.17.71-.31,1.31-.32.52,0,.98.19,1.29.46.15.13.27.28.34.41.07.14.1.26.1.35,0,.31-.06.51-.15.68-.07.13-.15.24-.26.35-.16.16-.39.32-.64.45-.25.14-.52.26-.79.41-.31.17-.64.42-.88.79-.12.18-.22.39-.28.61-.06.22-.09.45-.09.69v.46c0,.24.19.43.43.43h1.04c.24,0,.43-.19.43-.43v-.46c0-.09.01-.15.02-.19.02-.06.03-.07.06-.1.03-.03.09-.08.19-.14.16-.09.41-.21.69-.36.42-.23.94-.55,1.38-1.07.22-.26.41-.57.54-.93.13-.36.21-.76.2-1.2,0-.44-.12-.86-.31-1.23-.29-.56-.75-1.02-1.32-1.36-.57-.33-1.25-.54-1.99-.54-.92,0-1.68.24-2.25.57-.58.33-.82.71-.82.71-.1.08-.15.21-.15.33,0,.13.06.25.16.33Z"
                    />
                  </svg>
                  HARUMI FLAGについて
                </router-link>
                <ul>
                  <li>
                    <router-link to="/about/concept"
                      >街中に出会いがある<br />にぎわいの街</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about/design"
                      >地域全体のデザインに<br />一体感のある個性的な街</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about/location"
                      >みんなで守り、<br />育てていく森の街</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about/eco"
                      >様々なエネルギーを<br />巧みに使いこなす街</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about/legacy"
                      >オリンピック・<br />パラリンピックの<br />レガシーが息づく街</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/about/facility"
                      >みんなが使いこなし<br />楽しみをつなぐ街</router-link
                    >
                  </li>
                </ul>
              </li>
              <li class="menu__item" :class="{ active: isActive('/access') }">
                <router-link to="/access">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20.17 20.31"
                  >
                    <path
                      class="cls-1"
                      d="m10.08,0c-3.19,0-5.78,2.59-5.78,5.78s5.78,9.54,5.78,9.54c0,0,5.78-6.29,5.78-9.54,0-3.19-2.59-5.78-5.78-5.78Zm0,7.77c-1.1,0-2-.89-2-2s.89-2,2-2,2,.89,2,2-.89,2-2,2Z"
                    />
                    <path
                      class="cls-3"
                      d="m19.52,20.19c-1.16,0-1.77-.63-2.26-1.14-.44-.46-.79-.82-1.51-.82s-1.07.36-1.51.82c-.49.51-1.1,1.14-2.26,1.14s-1.77-.63-2.26-1.14c-.44-.46-.79-.82-1.51-.82s-1.07.36-1.51.82c-.49.51-1.1,1.14-2.26,1.14s-1.77-.63-2.26-1.14c-.44-.46-.79-.82-1.51-.82-.29,0-.52-.23-.52-.52s.23-.52.52-.52c1.16,0,1.77.63,2.26,1.14.44.46.79.82,1.51.82s1.07-.36,1.51-.82c.49-.51,1.1-1.14,2.26-1.14s1.77.63,2.26,1.14c.44.46.79.82,1.51.82s1.07-.36,1.51-.82c.49-.51,1.1-1.14,2.26-1.14s1.77.63,2.26,1.14c.44.46.79.82,1.51.82.29,0,.52.23.52.52s-.23.52-.52.52Z"
                    />
                  </svg>
                  アクセス
                </router-link>
                <ul>
                  <li v-if="accesstList.acf?.large_title_2">
                    <a
                      class="router-link-exact-active router-link-active"
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_2}`)
                      "
                      >{{ accesstList.acf?.large_title_2 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_3">
                    <a
                      class="router-link-exact-active router-link-active"
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_3}`)
                      "
                      >{{ accesstList.acf?.large_title_3 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_4">
                    <a
                      class="router-link-exact-active router-link-active"
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_4}`)
                      "
                      >{{ accesstList.acf?.large_title_4 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_5">
                    <a
                      class="router-link-exact-active router-link-active"
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_5}`)
                      "
                      >{{ accesstList.acf?.large_title_5 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_6">
                    <a
                      class="router-link-exact-active router-link-active"
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_6}`)
                      "
                      >{{ accesstList.acf?.large_title_6 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_7">
                    <a
                      class="router-link-exact-active router-link-active"
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_7}`)
                      "
                      >{{ accesstList.acf?.large_title_7 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_8">
                    <a
                      class="router-link-exact-active router-link-active"
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_8}`)
                      "
                      >{{ accesstList.acf?.large_title_8 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_9">
                    <a
                      class="router-link-exact-active router-link-active"
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_9}`)
                      "
                      >{{ accesstList.acf?.large_title_9 }}</a
                    >
                  </li>
                  <li v-if="accesstList.acf?.large_title_10">
                    <a
                      class="router-link-exact-active router-link-active"
                      @click="
                        handleMoveToAccess(`${accesstList.acf?.large_title_10}`)
                      "
                      >{{ accesstList.acf?.large_title_10 }}</a
                    >
                  </li>
                </ul>
              </li>
              <li
                class="menu__item"
                :class="{
                  active: isActive('/energy') || isActive('/environment'),
                }"
              >
                <router-link to="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 22.5 20.77"
                  >
                    <polygon
                      class="cls-1"
                      points="22.5 20.77 0 20.77 0 5.89 11.08 0 22.5 5.89 22.5 20.77"
                    />
                    <polygon
                      class="cls-4"
                      points="13.47 5.04 6.99 12.4 9.71 12.4 7.48 18.04 14.29 10.71 11.48 10.71 13.47 5.04"
                    />
                  </svg>
                  環境
                </router-link>
                <ul>
                  <li>
                    <router-link to="/energy"
                      >エネルギーマネジメント</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/energy-usage"
                      >エネルギーの利用状況</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/environment">環境への配慮</router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--    <a id="backTop-btn" onclick="window,topFunction()" title="Go to top">-->
    <!--      <img src="@/assets/img/back-to-top/icon-back-to-top.png" alt="backTop">-->
    <!--    </router-link>-->
  </header>
</template>
<script>
import axios from 'axios';
import { menu } from '@/assets/js/menu';

export default {
  name: 'HeaderView',
  data() {
    return {
      accesstList: {},
      isActiveCheck: '',
    };
  },
  mounted() {
    menu();
  },
  methods: {
    isActive(route) {
      if (route !== '/') {
        return this.$route.path.includes(route);
      } else {
        return this.$route.path === route;
      }
    },
    closeMenu() {
      const closeButton = document.querySelector('#menu-toggle');
      if (closeButton) {
        closeButton.click();
      }
    },
    titleHandleClick() {
      const menuToggle = document.querySelector('#menu-toggle');
      const body = document.querySelector('body');
      menuToggle.classList.remove('active');
      body.classList.remove('showmenu');
    },
    handleMoveToAccess(title) {
      if (this.$route.path === '/access') {
        var element_to_scroll_to = document.getElementById(title);
        element_to_scroll_to.scrollIntoView();
        this.isActiveCheck = title;
        Array.from(document.querySelectorAll('.access__tab__item')).forEach(
          function (el) {
            el.classList.remove('current');
          }
        );

        document.getElementById(`tab_${title}`).classList.add('current');
        if (window.innerWidth < 1023) {
          this.closeMenu();
        }
      } else {
        localStorage.setItem('accessKey', title);
        this.$router.push({ name: 'Access' }).catch(() => {});
        if (window.innerWidth < 1023) {
          this.closeMenu();
        }
      }
    },
  },

  created() {
    const accesstListlUrl =
      process.env.VUE_APP_BASE_URL +
      `/access/${process.env.VUE_APP_ID_ACCESS}?acf_format=standard&_fields=id,acf`;
    this.isLoading = true;
    axios
      .get(accesstListlUrl, {
        headers: {
          Authorization: `Basic ${process.env.VUE_APP_BASE_TOKEN}`,
        },
      })
      .then((response) => {
        this.accesstList = response.data;
        this.isLoading = false;
      })
      .catch((e) => {
        console.log(e);
        this.$router.push('/timeout');
      });
  },
};
</script>
